import React, { FC, KeyboardEvent, useEffect } from "react";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import { LogoSolar } from "src/framework/components/commons";
import {
  InputTextParameters,
  InputText,
  InputPassword,
  InputPasswordParameters,
} from "src/framework/components/forms";
import {
  FullWidthButton,
  fullWidthButtonProperties,
  IButtonProperties,
} from "src/framework/components/buttons";

import { authStore, doLogin, notifierStore } from "src/framework/store";
import "./style.css";
import { UrlUtil } from "src/framework/commons/UrlUtil";
import { ContaProvider } from "src/providers";

interface Credential {
  username: string;
  password: string;
}

interface LoginFormProperties {
  onLoggedIn?: () => void;
  onCancel?: () => void;
  textCancelar?: string;
}

const LoginForm: FC<LoginFormProperties> = ({
  onLoggedIn,
  onCancel,
  textCancelar = "Cancelar"
}) => {
  const [credentials, setCredentials] = React.useState<Credential>({
    username: "",
    password: "",
  });

  useEffect(() => {
    setCredentials(credentials);
  }, [credentials]);

  const inputEmailParameters: InputTextParameters = {
    label: "E-mail",
    fullWidth: true,
    value: credentials.username,
    sufix: (
      <IconButton size="small">
        <Icon>email</Icon>
      </IconButton>
    ),
    onChange: (evt: any) => {
      credentials.username = evt.target.value;
      setCredentials({ ...credentials });
      authStore.setCredentials(credentials);
    },
    onKeyUp: async (event: KeyboardEvent<HTMLInputElement>): Promise<void> => {
      if (event.key === "Enter") {
        if (credentials.password !== "" && credentials.username !== "") {
          const _isLogged = await doLogin(credentials)
          if (_isLogged && onLoggedIn) {
            onLoggedIn()
          }
        }
      }
    },
  };

  const inputSenhaParameters: InputPasswordParameters = {
    label: "Senha",
    obscureMode: true,
    value: credentials.password,
    onChange: (evt: any) => {
      credentials.password = evt.target.value;
      setCredentials({ ...credentials });
      authStore.setCredentials(credentials);
    },
    onKeyUp: async (event: KeyboardEvent<HTMLInputElement>): Promise<void> => {
      if (event.key === "Enter") {
        if (credentials.password !== "" && credentials.username !== "") {
          const _isLogged = await doLogin(credentials)
          if (_isLogged && onLoggedIn) {
            onLoggedIn()
          }
        }
      }
    },
  };

  const recuperarSenhaButton: fullWidthButtonProperties = {
    text: "Recuperar Senha",
    onClick: () => {
      UrlUtil.goto(`${process.env.REACT_APP_RECOVERY_CREDENTIALS_URL}`, true)
    },
  };

  const entrarButton: IButtonProperties = {
    text: "Entrar",
    disabled: credentials.username === "" || credentials.password === "",
    variant: "contained",
    color: "primary",
    disableElevation: true,

    onClick: async (): Promise<void> => {
      if (credentials.username === "" || credentials.password === "") {
        notifierStore.setNotifier({
          content: "E-mail e senha são obrigatórios",
          title: "Aviso!",
          timeOut: 3000,
          onClose: () => notifierStore.setOpen(false),
        });
        notifierStore.setOpen(true);
        return;
      }
      const _isLogged = await doLogin(credentials)
      if (_isLogged && onLoggedIn) {
        onLoggedIn()
      }
    },
  };

  return (
    <Grid
      id="login-form"
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item xs={12} md={8}>
        <LogoSolar fillIntelbras={"#00B26B"} width={"200px"} />
      </Grid>
      <Grid item xs={12} md={8}>
        <Paper variant="outlined">
          <Box p={2}>
            <Grid item xs={12}>
              <Box p={1}>
                <InputText {...inputEmailParameters} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box p={1}>
                <InputPassword {...inputSenhaParameters} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box p={1}>
                <FullWidthButton {...entrarButton} />
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box p={1}>
                <FullWidthButton {...recuperarSenhaButton} />
              </Box>
            </Grid>
            {onCancel && (<Grid item xs={12}>
              <Box p={1}>
                <FullWidthButton
                  text={textCancelar}
                  variant="text"
                  onClick={() => {
                    onCancel()
                  }}
                />
              </Box>
            </Grid>)}
          </Box>
        </Paper>
      </Grid>
    </Grid>
  );
};

export { LoginForm };
